import styled from 'styled-components'
import { MiniLogo } from '../../assets'

export const StyledMenuCards = styled.div`

`;

export const StyledLogo = styled.div`
  height: 120px;
`;

export const StyledCards = styled.div`
  max-height: calc(100vh - 120px);
  display: flex;
  justify-content: space-around;
  padding-top: 40px;
`;

export const StyledCard = styled.div`
  height: 710px;
  width: 580px;
  display: grid;
  grid-template-rows: 80% 20%;
  grid-template-columns: 1fr;
`;

export const ImageCard = styled.div`
  height: 100%;
  border: 1px solid green;
`;

export const MiniLogoContainer = styled.div`
  position: absolute;
  top: 39px;
  left: 0;
  right: 0;
  margin-left: auto; 
  margin-right: auto; 
  width: 44px;
  height: 44px;
  background: url(${MiniLogo}) no-repeat center center;
`;

